import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Link } from '@prikverwerker/models/link';
import { ApiService } from '@prikverwerker/services/api.service';
import { AlertService } from '@services/alert.service';
import { catchError, EMPTY, finalize, take, tap } from 'rxjs';

@Component({
  selector: 'mdk-delete-confirmation-survey-campaign-modal',
  templateUrl: './delete-confirmation-survey-campaign-modal.component.html',
})
export class DeleteConfirmationSurveyCampaignModalComponent {
  @Input() identifier!: string;
  @Output() campaignDeleted = new EventEmitter<void>();

  @ViewChild('deleteConfirmationSurveyCampaignOpenButton')
  private deleteConfirmationSurveyCampaignOpenButton!: ElementRef<HTMLElement>;
  @ViewChild('deleteConfirmationSurveyCampaignCloseButton')
  private deleteConfirmationSurveyCampaignCloseButton!: ElementRef<HTMLElement>;

  private surveyCampaignIdToDelete: string = '';
  deleteSurveyCampaignActionLink: Link | undefined;
  private isDeleting = false;

  constructor(
    private readonly apiService: ApiService,
    private readonly alertService: AlertService
  ) {}

  openModal(surveyCampaignId: string, deleteSurveyCampaignActionLink: Link | undefined) {
    this.surveyCampaignIdToDelete = surveyCampaignId;
    this.deleteSurveyCampaignActionLink = deleteSurveyCampaignActionLink;
    this.deleteConfirmationSurveyCampaignOpenButton.nativeElement.click();
  }

  private closeModal(): void {
    this.deleteConfirmationSurveyCampaignCloseButton.nativeElement.click();
  }

  onClickConfirmDelete() {
    if (this.isDeleting) return;

    if (!this.surveyCampaignIdToDelete) {
      this.alertService.onAlert({
        title: 'Campagne verwijderen mislukt',
        type: 'error',
        message: 'Geen geldige campagne geselecteerd.',
      });
      this.closeModal();

      return;
    }

    if (!this.deleteSurveyCampaignActionLink) {
      this.alertService.onAlert({
        title: 'Campagne verwijderen mislukt',
        type: 'error',
        message: 'Geen actie gevonden om de campagne te verwijderen.',
      });
      this.closeModal();

      return;
    }

    this.isDeleting = true;

    this.apiService
      .triggerDeleteAction$(this.deleteSurveyCampaignActionLink)
      .pipe(
        take(1), // Automatically unsubscribe after the first response
        tap(() => {
          this.closeModal();
          this.campaignDeleted.emit();
        }),
        catchError((error: Error) => {
          console.error('Error deleting survey campaign:', error);
          this.alertService.onAlert({
            title: 'Prikcampagne verwijderen mislukt',
            type: 'error',
            message: error.message ?? 'Er is een onbekende fout opgetreden.',
          });
          this.closeModal();
          return EMPTY; // Prevents subscription from continuing
        }),
        finalize(() => {
          this.isDeleting = false;
        })
      )
      .subscribe(() => {
        this.alertService.onAlert({
          title: 'Aanvraag om prikcampagne te verwijderen verstuurd',
          type: 'success',
          message: 'De aanvraag om de campagne te verwijderen is verstuurd.',
        });
      });
  }
}
